<template>
  <div class="container">
    <div class="content-container">
      <div>
        <div class="article-image-container">
          <div>
            <img class="article-intro-image" :src="detail.imageUrl" />
          </div>
          <div class="small_pic"></div>
        </div>
        <div style="padding: 0 30px; text-align: center">
          <div class="article-collection-title">{{ detail.title }}</div>
          <div class="article-collection-tag">{{ detail.label }}</div>
          <div class="article-collection-desc">{{ detail.description }}</div>
        </div>
      </div>
      <div class="divider" />
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="— 我是有底线的 —"
        @load="onLoad"
      >
        <li
          class="article-collection-list-item"
          v-for="item in list"
          :key="item.articleId"
          style="margin: 15px 15px"
          @click="onArticleClick(item)"
        >
          <div>
            <img
              class="article-collection-list-item-image"
              :src="item.subImageUrl"
            />
          </div>
          <div class="article-collection-list-item-text-container">
            <div v-if="item.titleCn" class="article-item-title-cn">
              {{ item.titleCn.replace(/&nbsp;/g, " ") }}
            </div>
            <div v-if="item.title" class="article-item-title-en">
              {{ item.title.replace(/&nbsp;/g, " ") }}
            </div>
          </div>
        </li>
        <template #finished>
          <div style="font-size: 10px">— 我是有底线的 —</div>
        </template>
      </van-list>
    </div>
    <!-- <footer style="display: fixed">
      <div>
          sdfasd 
      </div>
    </footer>-->
    <more-footer
      text="返回首页"
      :onBack="this.onBack"
      :onButtonClick="this.onBack"
    />
  </div>
</template>

<script>
import moment from "moment";
import MoreFooter from "../../../components/footer/MoreFooter";
import { getCollectionList, getCollectionDetail } from "@/api/article";
export default {
  name: "MoreArticle",
  props: {},
  components: {
    MoreFooter,
    // DateLabel,
  },
  data() {
    return {
      loading: false,
      finished: false,
      pageSize: 10,
      pageIndex: 1,
      detail: {
        introImage:
          "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=85805637,2302131739&fm=11&gp=0.jpg",
        title: "电影里的魔法乐园",
        desc:
          "本期内容选择《魔法奇缘》、《飞屋环游记》等电影主题，一起来感受魔法世界所带来的惊喜和快乐吧~",
        tag: "#小升初考试必读课外读物#",
      },
      list: [],
    };
  },
  activated() {
    getCollectionDetail({
      collectionId: this.$router.currentRoute.query.collectionId,
    }).then((result) => {
      this.detail = result.data;
    });
  },
  mounted() {},
  methods: {
    onLoad() {
      getCollectionList({
        collectionId: this.$router.currentRoute.query.collectionId,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((result) => {
          this.list = _.concat(this.list, result.data.records);
          this.pageIndex++;
          this.loading = false;
          if (result.data.records.length < this.pageSize) {
            this.finished = true;
          }
        })
        .catch(() => {});
    },
    onBack() {
      location.href = "/home";
    },
    onArticleClick(item) {
      this.$router.push({
        path: "/articleGuide",
        query: { articleId: item.articleId },
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 50px;
}

.content-container {
  flex: 1;
  overflow: scroll;
}

.divider {
  background-color: #e3e3e3;
  height: 1px;
  width: 90%;
  text-align: center;
  margin: auto;
}

// .tab-item-text {
// color: #3994E7;
// }
.card-item {
  // background-color :
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 20px 100px 0px #d6d6d6;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.article-image-container {
  display: flex;
  position: relative;
  text-align: center;
}

.article-intro-image {
  position: relative;
  width: 100%;
}

.article-source {
  margin-bottom: 38px;
  font-size: 11px;
  color: #999999;
  font-family: serif, SimSun, STSong;
}

.card-container {
  width: 100%;
}

.article-collection-list-item {
  height: 82px;
  display: flex;
  margin: 30px 0;
}

.article-collection-list-item-image {
  width: 82px;
  height: 82px;
  border-radius: 6px;
}

.article-collection-list-item-text-container {
  justify-content: center;
  display: flex;
  margin-left: 10px;
  flex-direction: column;
}

.article-item-title-cn {
  font-family: serif, SimSun, STSong;
  font-weight: bold;
  margin-bottom: 6px;
  font-size: 12px;
}

.article-item-title-en {
  font-family: serif, SimSun, STSong;
  font-size: 11px;
}

.article-collection-title {
  margin-top: 23px;
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-desc {
  margin-top: 20px;
  font-size: 12px;
  color: #333333;
  font-family: serif, SimSun, STSong;
}

.article-collection-tag {
  margin-top: 20px;
  font-size: 11px;
  color: #3994E7;
  font-family: serif, SimSun, STSong;
}

.article-collection-more {
  margin: 10px 0 20px 0;
  color: #3994E7;
}
</style>


// WEBPACK FOOTER //
// app/pages/tabs/Home/MoreArticle.vue